// extracted by mini-css-extract-plugin
module.exports = {"logo":"CardLayout_logo__jbDN5","wrapper":"CardLayout_wrapper__2IS59","link":"CardLayout_link__XePd1"};